import { Trans } from "i18n/Trans";

export const elKeepOld = (
  <em>
    <Trans i18nKey="main:selectionEditors.common.KeepOld" />
  </em>
);
